module.exports = __webpack_public_path__ + "img/4.10b6f2d7.jpg";